/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Rectangle, Texture, TilingSprite, utils } from 'pixi.js-legacy';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { Swimlane } from 'src/app/app-data/models/Swimlane';
import { rgbaToNumber } from 'utils/color-utils';
import { EventBinder } from '../interaction';
import { SWIMLANE_GRAPHICS, SWIMLANE_LABEL_SETTINGS, SWIMLANE_SPOT } from './SwimlaneConst';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';
import { CursorType } from '@appCanvasCommon/events/cursor-type.enum';

export class SwimlaneLine extends TilingSprite {
	private _lastColor: string;
	private _binder = new EventBinder(this, 'hammer-panstart', 'hammer-panend');
	constructor(
		private swimlaneModel: Swimlane,
		private canvasAngularLand: CanvasAngularLand,
		private spot: SWIMLANE_SPOT,
		texture: Texture = utils.TextureCache[SWIMLANE_GRAPHICS.SWIMLANE_LINE]
	) {
		super(texture);

		this.hitArea = new Rectangle(0, 0, 1, 1);

		this._binder.add('hammer-panstart', (event) => {
			// let filteredObservable = this.planState.swimlanes.data.editList$.pipe(
			// 	map(list => {
			// 		let map = new Map
			// 		return
			// 	})
			// );
			const tempMap = new Map();
			tempMap.set(swimlaneModel.$id, swimlaneModel);
			return this.canvasAngularLand.swimlaneDragService.dragEdgeStart(event.center, tempMap);
		});
		this._binder.add('hammer-pan', (event) => {
			if (spot === SWIMLANE_SPOT.TOP) {
				return this.canvasAngularLand.swimlaneDragService.dragTopEdge(event.center);
			} else if (spot === SWIMLANE_SPOT.BOTTOM) {
				return this.canvasAngularLand.swimlaneDragService.dragBottomEdge(event.center);
			}
		});
		this._binder.add('hammer-panend', (event) => {
			return this.canvasAngularLand.swimlaneDragService.dragEdgeEnd(event.center);
		});
	}

	public setEdit(width: number, isEdit: boolean) {
		const targetMode: EventMode = isEdit ? EventMode.Static : EventMode.Auto;
		this.setEventMode(targetMode);
		this.setHitArea(width);
	}

	public setEventMode(value: EventMode): void {
		this.eventMode = value;

		if (this.eventMode === EventMode.Static) {
			this.cursor = CursorType.RowResize;
			this.setColor(SWIMLANE_LABEL_SETTINGS.LINE_EDIT_COLOR);
		} else {
			this.cursor = CursorType.None;
			this.setColor(SWIMLANE_LABEL_SETTINGS.LINE_NORMAL_COLOR);
		}
	}

	public setColor(color: string) {
		if (color !== this._lastColor) {
			this.tint = rgbaToNumber(color);
			this._lastColor = color;
		}
	}

	public setHitArea(width: number) {
		(<Rectangle>this.hitArea).x = 0;
		(<Rectangle>this.hitArea).y = -SWIMLANE_LABEL_SETTINGS.LINE_HIT_AREA_HEIGHT;
		(<Rectangle>this.hitArea).width = width;
		(<Rectangle>this.hitArea).height = SWIMLANE_LABEL_SETTINGS.LINE_HIT_AREA_HEIGHT * 2; // Times by two to offset the y value form above
	}

	public override destroy() {
		super.destroy();
	}
}
